var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"tab"},[_vm._t("default"),(this.$slots.footer)?_c('div',{staticClass:"inline-block w-full p-4"},[_vm._t("footer")],2):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }